<!--
 * @Description: 原物料过磅打印
 * @Author: Roger Wei
 * @Date: 2021-11-28 19:17:04
 * @LastEditTime: 2021-11-30 20:39:07
 * @LastEditors: Roger Wei
 * @CopyRight: itence.com
 * @Reference: 
-->

<template>
  <div id="print-dom" ref="print-dom" style="background: #fff; position: fixed; top: -10000px">
    <div class="roger" style="position: relative; margin: 2mm 0mm 0mm 2mm" :style="{ width: canvasSize.x + 'cm', height: canvasSize.y + 'cm' }">
      <div
        v-for="(item, index) in dataConfList"
        :key="index"
        style="position: absolute; display: inline"
        :style="{
          left: item.attr.left / cmunit + 'cm',
          top: item.attr.top / cmunit + 'cm',
          zIndex:item.type === 'image'? 1 : 99,
        }"
        class="ticket-item"
      >
        <!-- 文本控件 -->
        <div v-if="item.type === 'text'">
          <div
            v-if="item.dataAttr ? item.dataAttr.dataSource != 'signature' : true"
            :style="{
              fontSize: item.attr.fontSize + 'px',
              width: item.attr.width + 'cm',
              fontWeight: item.attr.fontWeightBold ? 'bold' : 'normal',
              fontStyle: item.attr.fontStyleItalic ? 'italic' : 'normal',
              textDecoration: item.attr.textDecorationUnderLine ? 'underline' : 'normal',
            }"
          >
            {{ item.dataAttr.type === "fixed" ? item.value : data[item.dataAttr.dataSource] }}
          </div>
          <div v-else :style="{ width: item.attr.width + 'cm', transform: 'rotate(270deg)' }">
            <img v-if="dataArr[item.dataAttr.dataSource]" :src="printFileUrl + dataArr[item.dataAttr.dataSource]" alt="" :style="{ width: item.attr.width + 'cm' }" />
            <span v-else>图片控件</span>
          </div>
        </div>
        <!-- 图片控件 -->
        <div v-if="item.type === 'image'" :style="{ width: item.attr.width + 'cm' }">
          <img v-if="item.value" :src="printFileUrl + item.value" alt="" :style="{ width: item.attr.width + 'cm' }" />
          <span v-else>图片控件</span>
        </div>
        <!-- 二维码控件 -->
        <div v-if="item.type === 'qrcode'" :style="{ width: item.attr.width + 'cm' }">
          <span v-if="(item.dataAttr.type === 'fixed' && !item.value) || (item.dataAttr.type === 'custom' && !item.dataAttr.dataSource.length)">二维码控件</span>
          <genQrCode v-else ref="genQrCode" :key="Math.random()" :item="item" :dataArr="dataArr"></genQrCode>
        </div>
        <!-- 横线控件 -->
        <div
          v-if="item.type === 'horizontalLine'"
          :style="{
            background: '#000',
            height: item.attr.height + 'px',
            width: item.attr.width + 'cm',
          }"
        ></div>
        <!-- 竖线控件 -->
        <div
          v-if="item.type === 'verticalLine'"
          :style="{
            background: '#000',
            height: item.attr.height + 'cm',
            width: item.attr.width + 'px',
          }"
        ></div>
      </div>
    </div>
  </div>
</template>
<script>
import genQrCode from "./../platform/ICPS/basicConfig/components/genQrCode.vue";
import { getSiteTicketTemplateList, getConditionList } from "@/api/basicConfig/ticketTemplate";
export default {
  name: "template-printer",
  props: ["stationId", "data", "userName", "userSelectIndex", "secondKey", "firstKey", "printerName"],
  components: { genQrCode },
  data() {
    return {
      canPrint: false,
      cmunit: 37.78,
      confList: [],
      dataConfList: [],
      availableConfList: [],
      canvasSize: {
        x: 0,
        y: 0,
      },
      requestCnt: 0,
      hasImage: false,
      dataArr: [],
      printFileUrl : process.env.VUE_APP_API_Print_File,
    };
  },
  mounted() {
    if (!this.firstKey) {
      this.firstKey = "weigthTicket";
    }
    if (!this.secondKey) {
      this.secondKey = "rawSupply";
    }
    this.getConf();
    // console.log(2, this.stationId, this.data)
    if (this.userName) {
      this.data.userRealName = this.userName;
    }
    //打印组件初始化
    this.$pluginName.init({
      host: "http://localhost:17521", // 打印客户端的地址
      token: "icpsPrint", // 与打印客户端相同的 token
    });
  },
  watch: {
    data(val) {
      if (val) {
        this.$set(this, "dataArr", val);
        this.dataArrChange();
        console.log(this.dataArr);
      }
    },
  },
  methods: {
    // getConf() {
    //   // 获取打印配置
    //   getSiteTicketTemplateList({
    //     stationId: this.stationId,
    //     firstLevelMenuKey: this.firstKey,
    //     secondLevelMenuKey: this.secondKey,
    //     page: 1,
    //     pageSize: 1000,
    //   }).then(res => {
    //     if (res.code == 1001 && res.data.totalRows > 0) {
    //       this.confList = res.data.data;
    //       this.confList.map(item => {
    //         this.getCondition(item);
    //       });
    //       this.$emit("confList", this.confList);
    //     }
    //   });
    // },
    getConf() {
      // 获取打印配置
      getSiteTicketTemplateList({
        stationId: this.stationId,
        firstLevelMenuKey: this.firstKey,
        secondLevelMenuKey: this.secondKey,
        page: 1,
        pageSize: 1000,
      }).then(res => {
        if (res.code == 1001 && res.data.totalRows > 0) {
          this.confList = res.data.data;
          getConditionList({ id: this.stationId }).then(res => {
            if (res.code == 1001) {
              this.confList.map(item => {
                item.conditionList = res.data.conditionList || [];
                this.requestCnt++;
                if (this.requestCnt == this.confList.length) {
                  this.availableConfList = this.confList.filter(item => {
                    let ret = true; // 如果是空，默认可选

                    if (item.conditionList.length) {
                      let condition;
                      for (let i = item.conditionList.length - 1; i >= 0; i--) {
                        condition = item.conditionList[i];
                        if (this.data[condition.conditionName] !== condition.conditionData) {
                          ret = false;
                          break;
                        }
                      }
                    }
                    return ret;
                  });
                }
              });

            }
          });
          this.$emit("confList", this.confList);
        }
      });
    },
    getCondition(item) {
      getConditionList({ id: this.stationId }).then(res => {
        if (res.code == 1001) {
          item.conditionList = res.data.conditionList || [];
          this.requestCnt++;
          if (this.requestCnt == this.confList.length) {
            this.availableConfList = this.confList.filter(item => {
              let ret = true; // 如果是空，默认可选

              if (item.conditionList.length) {
                let condition;
                for (let i = item.conditionList.length - 1; i >= 0; i--) {
                  condition = item.conditionList[i];
                  if (this.data[condition.conditionName] !== condition.conditionData) {
                    ret = false;
                    break;
                  }
                }
              }

              return ret;
            });
          }
        }
      });
    },
    chosenConf(confList) {
      let ret = false;
      let sortConfList = confList.sort((a, b) => {
        return a.priority > b.priority;
      });
      console.log('-------2-------',confList)
      console.log('-------3-------',sortConfList)
      if (sortConfList.length) {
        let content = sortConfList[0].content;
        let data = JSON.parse(content);
        this.dataConfList = data.dataList;
        this.canvasSize = data.canvasSize;
        console.log(this.dataConfList);
        this.$emit("printDom", this.$refs["print-dom"]);
        ret = true;

        this.setImageTimeOut();
      }
      return ret;
    },
    setImageTimeOut() {
      let items = this.dataConfList.filter(item => {
        return item.type == "image";
      });
      this.hasImage = items.length > 0;
    },
    //为了解决发货时间要分为日期和时间的问题
    dataArrChange(){
        //发货时间不为空 就分为两个
        if(this.dataArr.proTime) {
          this.dataArr['proTimeDate'] = new Date(this.dataArr.proTime).Format("yyyy-MM-dd")
          this.dataArr['proTimeTime'] = new Date(this.dataArr.proTime).Format("hh:mm:ss")
        }
    },
    print(printIndex,printData) {
      if (printIndex) {
        this.userSelectIndex = printIndex;
      }
      if (printData) {
        this.$set(this, "dataArr", printData);
        this.dataArrChange();
      }
      let hasConf = false;
      console.log("-------1----", this.userSelectIndex);
      if (this.userSelectIndex !== "" || this.userSelectIndex !== null) {
        hasConf = this.chosenConf(this.confList.filter(item => item.templateId == this.userSelectIndex));
      } else {
        hasConf = this.chosenConf(this.confList);
      }
      console.log("-------4------",this.confList);
      console.log("-----5---------",hasConf);
      console.log("-----6---------",this.dataArr);
      if (!hasConf) {
        this.$message.warning("没有合适的打印模板");
        this.$emit("closeDialog");
        return;
      }
      this.$forceUpdate();
      this.$nextTick(() => {
        setTimeout(() => {
          this.$emit("closeDialog");
          // 获取打印机列表
          console.log("to print");
          let print = this.$refs["print-dom"].innerHTML; //获取目标区域
          console.log(print)
          const hiprintTemplate = new this.$pluginName.PrintTemplate();
          //模板对象获取打印机列表
          const printerList_ = hiprintTemplate.getPrinterList();
          console.log(printerList_);
          if (window.hiwebSocket.opened === false) {
            this.$message.warning("未启动打印服务，使用浏览器打印方式！");
            console.log(this.printerName + "浏览器打印");
            const iframeDom = document.createElement("iframe");
            const attrObj = {
              height: 0,
              width: 0,
              border: 0,
              id: "iframe",
            };
            const styleObj = {
              position: "fixed",
              "z-index": "-999",
            };
            Object.entries(attrObj).forEach(([key, value]) => iframeDom.setAttribute(key, value));
            Object.entries(styleObj).forEach(([key, value]) => {
              iframeDom.style[key] = value;
            });
            document.body.appendChild(iframeDom);
            const iframeDocs = iframeDom.contentWindow.document;
            iframeDocs.body.style.margin = "0px";
            iframeDocs.write(print);
            iframeDocs.write('<style media="print">@page {size: auto;  margin: 0mm; }</style>');
            window.setTimeout(
              function () {
                iframeDom.contentWindow.print();
                document.body.removeChild(iframeDom);
              },
              this.hasImage ? 5000 : 1500
            );
          } else {
            let printIndex = printerList_.findIndex(item => item.name == this.printerName);
            let printerName = printIndex == -1 ? "" : this.printerName;
            console.log(printerName);
            hiprintTemplate.printByHtml2(print, {
              printer: printerName, // 打印机名称，不填则默认打印机
              title: "任务队列中名称",
            }); //直接打印，需要安装客户端 下面会提到客户端的安装
          }
        }, 500);
      });
    },
  },
};
</script>
